import requestCtxs from '@/sealFilter/requestCtxs'

// 首页数据
export function getClassifyData (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/homepage/colinfo/querybyconditon',
        method: 'post',
        data
    })
}

export function generator (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/visit/sign/generator',
        method: 'post',
        data
    })
}

//阅读报告
//借阅排行 参数：userId，orgId，borrowRankYear（传年份，比如2024）
export function borrowRank (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/borrow/queryrank/byuser',
        method: 'post',
        data
    });
}
//荐购排行 参数：readerId，orgId，rmdRankYear（传年份，比如2024）
export function rmdRank (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebook/rmd/query/rmdrank/byuser',
        method: 'post',
        data
    });
}
//阅读排行 参数：creatorId，orgId，readRandYear（传年份，比如2024）
export function readRank (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/ranking/byuser',
        method: 'post',
        data
    });
}
//读过最火的一本书 参数：creatorId，orgId，readRandYear（传年份，比如2024）
export function popularRank (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/popular/ebook',
        method: 'post',
        data
    });
}

//用户阅读历史 参数：creatorId，readRandYear（传年份，比如2024）
export function readhistory (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/readinfo/byuser',
        method: 'post',
        data
    });
}

//用户阅读历史 参数：creatorId，readRandYear（传年份，比如2024）
export function readhistoryByprocess (data) {
    return requestCtxs({
        url: '/portal/ttv3/ebookreader/book/reading/query/read/process',
        method: 'post',
        data
    });
}

//查询读书笔记排行 参数：creatorId，orgId，textMarkRankYear（传年份，比如2024）
export function readNoteRank (data) {
    return requestCtxs({
        url: '/ebookreader/ttv3/ebookreader/demo/book/text/mark/query/markcount/byuser',
        method: 'post',
        data
    });
}

//查询阅读时长排行 参数：creatorId，orgId，readTimeRankYear（传年份，比如2024）    返回参数readTotalTime单位是小时
export function readTimeRank (data) {
    return requestCtxs({
        url: '/ebookreader/ttv3/ebookreader/book/reading/query/readtime/byuser',
        method: 'post',
        data
    });
}

//我的收藏
export function collectionList (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/myfavorite/books/queryByCondition',
        method: 'post',
        data
    });
}

//加入收藏
export function insertCollection (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/myfavorite/books/insert',
        method: 'post',
        data
    });
}
//取消收藏
export function removeCollection (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/myfavorite/books/delete',
        method: 'post',
        data
    });
}
//活动列表
export function activityList (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/libactivity/query/bypage',
        method: 'post',
        data
    });
}
//活动报名
export function signActivity (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/libactivity/apply/insert',
        method: 'post',
        data
    });
}
//活动报名上传附件
export function uploadActivitySign (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/libactivity/apply/file/upload',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/colinfo.js